import React from 'react';

export const ForgeUnitoAsanaProdIcon = (): React.JSX.Element => {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3059_452)">
				<path
					d="M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z"
					fill="white"
				/>
				<path
					d="M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z"
					stroke="#0B1228"
					strokeOpacity="0.14"
					strokeWidth="1.017"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M21.6504 16.0587C19.2481 16.0587 17.3008 18.0603 17.3008 20.5294C17.3008 22.9984 19.2481 25 21.6504 25C24.0527 25 26 22.9984 26 20.5294C26 18.0603 24.0527 16.0587 21.6504 16.0587ZM10.3496 16.0591C7.94742 16.0591 6 18.0603 6 20.5294C6 22.9984 7.94742 25 10.3496 25C12.752 25 14.6995 22.9984 14.6995 20.5294C14.6995 18.0603 12.752 16.0591 10.3496 16.0591ZM20.3496 10.4704C20.3496 12.9396 18.4022 14.9414 16 14.9414C13.5977 14.9414 11.6504 12.9396 11.6504 10.4704C11.6504 8.00174 13.5977 6 16 6C18.4022 6 20.3496 8.00174 20.3496 10.4704Z"
					fill="#F06A6A"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3059_452">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
